define('modules/Favorites/FavoritesGuest',[
    'jquery',
    'global/all',
    'modules/Store/StorePermissionService',
], function ($, Roc, StorePermissionService) {
    'use strict';

    function init() {
        if (!StorePermissionService.isLoggedIn()) {
            $(".roc-itemTools-option .icon-heart").hide();
            $(".roc-addToCartFavoritesWrapper").hide();
        }
    };

    var FavoritesGuest = {
        init: init
    };

    Roc.Logger.debug('FavoritesGuest.js Loaded:', FavoritesGuest);

    return FavoritesGuest;
});
